import { toast } from 'react-toastify';


const Toastmessage = async (message, status) => {
    if(status){
        toast.success(message); // Show success toast
    } else {
        toast.error(message)
    }
};


export default Toastmessage;
